export class SearchCriteriaError extends Error {
    constructor(message: string) {
        super(message);

        Object.setPrototypeOf(this, SearchCriteriaError.prototype);
    }
}
